import React, { useMemo, useRef, useState } from "react";

import { InferenceRequestLog } from "models/InferenceRequestLog";
import { AgGridReact } from "ag-grid-react";
import {
  ColDef,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy,
} from "ag-grid-community";
import moment from "moment";

interface RequestLogTableProps {
  data: InferenceRequestLog[];
}

const RequestLogTable = ({ data }: RequestLogTableProps) => {
  const gridRef = useRef<AgGridReact<InferenceRequestLog>>(null);
  const [colDefs] = useState<ColDef<InferenceRequestLog>[]>([
    {
      field: "created_timestamp",
      headerName: "Request Date",
      valueFormatter: (params) => moment(params.value).format("YYYY/MM/DD"),
    },
    {
      field: "created_timestamp",
      headerName: "Request Time",
      valueFormatter: (params) => moment(params.value).format("H:mm:ss"),
    },
    // {
    //   field: "origin_ip",
    //   headerName: "Origin",
    // },
    {
      field: "response_time",
      headerName: "Response Time",
      width: 100,
      valueFormatter: (params) =>
        (Math.round(params.value * 100) / 100).toString() + "ms",
    },
    // { field: "credit_cost", headerName: "Credit Cost" },
  ]);

  const autoSizeStrategy = useMemo<
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy
  >(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  return (
    <AgGridReact
      ref={gridRef}
      rowData={data}
      columnDefs={colDefs}
      autoSizeStrategy={autoSizeStrategy}
    />
  );
};

export default RequestLogTable;
